var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h-link',_vm._g(_vm._b({staticClass:"small-card-base-cta-link",attrs:{"color":"var(--color-branding)"}},'h-link',_vm.$attrs,false),_vm.$listeners),[_vm._v(_vm._s(_vm.text))])}
var staticRenderFns = []

export { render, staticRenderFns }